// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__9YnuF","requiredAsterisk":"Info_requiredAsterisk__V-tPN"};